/* raw layout hash: _anonymous-web-layout-wvalbl:fdf16fd6d8a92898d19e8cc36b1b2fb059354d12329b5046473ef0289050ec65 */
import React from "react";
import AnonymousShell from "./AnonymousShell.jsx";

// Layout "_anonymous-web-layout-wvalbl" (RawHTMLDesign/layouts/_anonymous-web-layout-wvalbl.html)
export default function AnonymousWebLayoutWvalbl({ children }) {
  return <AnonymousShell>{children}</AnonymousShell>;
}
